"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewFormVersion = exports.cloneForm = exports.deleteFormItem = exports.deleteFormSection = exports.discardFormDraft = exports.deleteForm = exports.updateFormStatus = exports.addOrUpdateFormItem = exports.addOrUpdateFormSection = exports.updateForm = exports.getFormBuilderForm = exports.downloadFormTemplates = exports.getFormTemplates = void 0;
var network_1 = require("../network");
var utils_1 = require("../utils");
function getFormTemplates(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "/builder/forms" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.getFormTemplates = getFormTemplates;
function downloadFormTemplates(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["mediaType"]);
            return [2, network_1.simpleGetFile({
                    path: "/builder/forms" + queryParams,
                    mediaType: params.mediaType,
                })];
        });
    });
}
exports.downloadFormTemplates = downloadFormTemplates;
function getFormBuilderForm(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["formId"]);
            return [2, network_1.simpleGet({
                    path: "/builder/forms/" + params.formId + queryParams,
                })];
        });
    });
}
exports.getFormBuilderForm = getFormBuilderForm;
function updateForm(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["form"]);
            return [2, network_1.simplePut({
                    path: "/builder/forms" + queryParams,
                    body: params.form,
                })];
        });
    });
}
exports.updateForm = updateForm;
function addOrUpdateFormSection(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["formId", "section"]);
            return [2, network_1.simplePut({
                    path: "/builder/forms/" + params.formId + "/sections" + queryParams,
                    body: params.section,
                })];
        });
    });
}
exports.addOrUpdateFormSection = addOrUpdateFormSection;
function addOrUpdateFormItem(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["formId", "sectionId", "item"]);
            return [2, network_1.simplePut({
                    path: "/builder/forms/" + params.formId + "/sections/" + params.sectionId + "/items" + queryParams,
                    body: params.item,
                })];
        });
    });
}
exports.addOrUpdateFormItem = addOrUpdateFormItem;
function updateFormStatus(_a) {
    var formId = _a.formId, status = _a.status;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePut({
                    path: "/builder/forms/" + formId + "/workflow-type/" + status,
                })];
        });
    });
}
exports.updateFormStatus = updateFormStatus;
function deleteForm(_a) {
    var formId = _a.formId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleDelete({
                    path: "/builder/forms/" + formId,
                })];
        });
    });
}
exports.deleteForm = deleteForm;
function discardFormDraft(_a) {
    var formId = _a.formId;
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, network_1.deleteAuthJson({
                        path: "/builder/forms/" + formId + "/draft",
                    })];
                case 1:
                    res = _b.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.discardFormDraft = discardFormDraft;
function deleteFormSection(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryParams = utils_1.buildQueryParams(params, ["formId", "sectionId"]);
                    return [4, network_1.deleteAuthJson({
                            path: "/builder/forms/" + params.formId + "/sections/" + params.sectionId + queryParams,
                        })];
                case 1:
                    res = _a.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.deleteFormSection = deleteFormSection;
function deleteFormItem(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryParams = utils_1.buildQueryParams(params, ["formId", "sectionId"]);
                    return [4, network_1.deleteAuthJson({
                            path: "/builder/forms/" + params.formId + "/sections/" + params.sectionId + "/items" + queryParams,
                        })];
                case 1:
                    res = _a.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.deleteFormItem = deleteFormItem;
function cloneForm(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["formId"]);
            return [2, network_1.simpleGet({
                    path: "/builder/forms/" + params.formId + "/clone" + queryParams,
                })];
        });
    });
}
exports.cloneForm = cloneForm;
function createNewFormVersion(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "/builder/forms/" + params.formId + "/new-version",
                })];
        });
    });
}
exports.createNewFormVersion = createNewFormVersion;
//# sourceMappingURL=formBuilderResource.js.map